import { Injectable, inject } from '@angular/core';

import { NETWORK_REPOSITORY, NetworkRepository } from '@app/domain/repositories/network/network.repository.contract';
import { AppError, ErrorTypes } from '@app/entities/models/error/error.model';
import { ErrorService } from '@app/services';

import { NetworkUseCases } from './network.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class NetworkUseCasesImpl implements NetworkUseCases {
  #networkRepository: NetworkRepository = inject(NETWORK_REPOSITORY);
  private errorService = inject(ErrorService);

  hasConnection(): boolean {
    return navigator.onLine;
  }

  doIfConnection(callback: () => void, pageWhenOnline = null, callbackOffline?: () => void) {
    if (this.hasConnection()) {
      return callback();
    }
    if (callbackOffline) {
      callbackOffline();
    }
    this.redirectIfOffline(pageWhenOnline);
  }

  redirectIfOffline(pageWhenOnline = null) {
    if (this.hasConnection()) {
      return;
    }
    return this.errorService.add(new AppError(ErrorTypes.OFFLINE, undefined, { pageWhenOnline }));
  }

  async isOnline(): Promise<boolean> {
    if (!this.hasConnection()) {
      this.#networkRepository.getLogger().error('No connection available');
      return false;
    }

    return this.hasServerConnection(5, 5000, true);
  }

  hasServerConnection(maxRetries: number, requestTimeout: number, noRetry: boolean): Promise<boolean> {
    return this.#networkRepository.hasServerConnection(maxRetries, requestTimeout, noRetry);
  }
}
